import React from 'react'
import { cn } from '../../lib/utils'
import { Clock, Inbox, ListMusic, Music, Search } from 'lucide-react'

const EmptyState = ({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel,
  onAction,
  className,
  size = 'default'
}) => {
  const sizeClasses = {
    small: {
      container: 'py-5',
      icon: 'h-8 w-8',
      title: 'text-sm',
      description: 'text-xs'
    },
    default: {
      container: 'py-8',
      icon: 'h-11 w-11',
      title: 'text-base',
      description: 'text-sm'
    },
    large: {
      container: 'py-12',
      icon: 'h-14 w-14',
      title: 'text-lg',
      description: 'text-base'
    }
  }

  const sizes = sizeClasses[size] || sizeClasses.default

  return (
    <div className={cn('flex flex-col items-center justify-center text-center', sizes.container, className)}>
      <div className="mb-3 rounded-full border border-white/15 bg-white/5 p-3 text-[var(--room-muted)]">
        <Icon className={sizes.icon} strokeWidth={1.6} />
      </div>

      {title ? <h3 className={cn('font-semibold text-[var(--room-text)]', sizes.title)}>{title}</h3> : null}
      {description ? (
        <p className={cn('mx-auto mt-1 max-w-xs text-[var(--room-muted)]', sizes.description)}>{description}</p>
      ) : null}

      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="room-focus-ring mt-4 inline-flex h-11 items-center justify-center rounded-xl border border-[color:var(--room-primary)] bg-[color:rgba(46,168,255,0.22)] px-4 text-sm font-semibold text-[var(--room-text)] hover:bg-[color:rgba(46,168,255,0.3)]"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  )
}

export const EmptyQueueState = ({ onAddSong }) => (
  <EmptyState
    icon={ListMusic}
    title="Queue is empty"
    description="Search for songs and add them to the queue to get started."
    actionLabel={onAddSong ? 'Add a song' : undefined}
    onAction={onAddSong}
  />
)

export const EmptyHistoryState = () => (
  <EmptyState
    icon={Clock}
    title="No songs played yet"
    description="Songs that finish will appear in history."
    size="small"
  />
)

export const EmptySearchState = ({ query, onYouTubeSearch, isSearchingYouTube, hasSearchedYouTube }) => (
  <EmptyState
    icon={Search}
    title={query ? `No results for "${query}"` : 'Search for songs'}
    description={
      query
        ? (hasSearchedYouTube ? 'Try a different search term.' : 'Not in catalog yet? Queue from YouTube.')
        : 'Enter a song name, artist, or paste a YouTube URL.'
    }
    actionLabel={query && onYouTubeSearch && !hasSearchedYouTube ? (isSearchingYouTube ? 'Searching YouTube...' : 'Queue from YouTube') : undefined}
    onAction={onYouTubeSearch}
  />
)

export const EmptyProcessingState = () => (
  <EmptyState
    icon={Music}
    title="No processing jobs"
    description="Songs submitted from YouTube will appear here."
    size="small"
  />
)

export default EmptyState
